/**
 * Mirror API - public helpers to resolve mirror/salon from QR mirrorId.
 */
import api from '../utils/api';
import { ENDPOINTS } from '../config/endpoints';

const { MIRRORS } = ENDPOINTS;

export const resolveMirror = (mirrorId) => api.get(MIRRORS.resolve(mirrorId));

